module.exports = __webpack_public_path__ + "img/sign-45.f48de12a.jpg";